import { moduleNamespace } from '../store.config';

export const addNamespace = (action: string): string =>
	moduleNamespace + '/' + action;
